import React, { useState, useCallback, useEffect } from "react";

//react-bootstrap
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//httpClient
import AuthenticationClient from './../../httpClient/Authentication'; 

const initialUserRecord = {
	employeeNumber: "",
	fullName: "",
	email: ""
}
function AddUser() {
  const [show, setShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isValidated, setIsValidated] = useState(false);

  const [userRecord, setUserRecord] = useState(initialUserRecord);

  const updateUserRecord = useCallback((e) => {
    const { name, value } = e.target;
    setUserRecord((userRecord) => {
      return {
        ...userRecord,
        [name]: value,
      };
    });
  }, []);

	//validation for submit button
	useEffect(() => {
		//check for gmr email
		const splitEmail = userRecord.email.split('@');
		const domain = splitEmail.length > 0 ? splitEmail[1] : '';

    let emailAddressPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!emailAddressPattern.test(userRecord.email) || domain.toLowerCase() !== 'gmr.net') {
      setIsValidated(false);
    } else if (userRecord.fullName.length < 2 || userRecord.employeeNumber.length < 2){
      setIsValidated(false);
		} else {
      setIsValidated(true);
    }
	}, [userRecord])

	//validation to control what message to play
	//not even sure if necessary since submit is disabled until all these are true
  const validateInput = () => {
		//check for gmr email
		const splitEmail = userRecord.email.split('@');
		const domain = splitEmail.length > 0 ? splitEmail[1] : '';

    //validate Input Fields
    let emailAddressPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!emailAddressPattern.test(userRecord.email) || domain.toLowerCase() !== 'gmr.net') {
      setErrorMessage("Please enter a valid Email Address");
      return;
    } else if (userRecord.fullName.length < 2 || userRecord.employeeNumber.length < 2){
			setErrorMessage("Please enter a name and employee number");
      return;
		} else {
      setErrorMessage("");
			createAccount();
    }
  };

  const createAccount = () => {
    setLoading(true);
		setSuccessMessage('');
		setErrorMessage('');

    AuthenticationClient.addUser(userRecord)
		.then((data) => {
			setLoading(false);
			setSuccessMessage(data.Message);
		})
		.catch((err) => {
			setLoading(false);
			setErrorMessage(err.response.data.Message);
		});
  };

  const handleClose = () => {
		setLoading(false);
		setSuccessMessage('');
		setErrorMessage('');
		setUserRecord(initialUserRecord);
		setShow(false);
		setIsValidated(false)
	}
  const handleShow = () => setShow(true);

  return (
    <>
			<Row className="mb-3">
				<Col>
					<Button variant="primary" onClick={handleShow}>
						Add New User
					</Button>
				</Col>
				{/* <p className="m-auto">Click the button on the left to add a new user</p> */}
			</Row>

      <Modal backdrop={false} show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Enter New User Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
					<h3>Please fill out all information</h3>
					{errorMessage.length > 0 && (
						<Container fluid className="message is-danger">
							<div className="message-header">
								<p>Error</p>
								<button
									className="delete"
									aria-label="delete"
									onClick={() => setErrorMessage("")}
								/>
							</div>
							<div className="message-body">
								<strong>{errorMessage}</strong>
							</div>
						</Container>
					)}
					{successMessage.length > 0 && 
						<Container fluid className="message is-success">
							<div className="message-header">
								<p>Success</p>
								<button className="delete" aria-label="delete" onClick={()=>setSuccessMessage('')} />
							</div>
							<div className="message-body">
								<strong>{successMessage}</strong>
							</div>
            </Container>}

          <div className="box page-main">
            <div className="field">
              <label htmlFor="" className="label">
                Employee Number*
              </label>
              <div className="control">
                <input
                  type="input"
                  name="employeeNumber"
									disabled={loading}
                  value={userRecord.employeeNumber}
                  placeholder="e.g. 1986212"
                  className="input"
                  onChange={updateUserRecord}
                  required
                />
              </div>
            </div>

            <div className="field">
              <label htmlFor="" className="label">
                Full Name*
              </label>
              <div className="control">
                <input
                  type="input"
                  name="fullName"
									disabled={loading}
                  value={userRecord.fullName}
                  placeholder="e.g. Alex Smith"
                  className="input"
                  onChange={updateUserRecord}
                  required
                />
              </div>
            </div>

            <div className="field">
              <label htmlFor="" className="label">
                Email*
              </label>
							Must be a valid company email 
              <div className="control">
                <input
                  type="input"
                  name="email"
									disabled={loading}
                  value={userRecord.email}
                  placeholder="e.g. alex.smith@gmr.net"
                  className="input"
                  onChange={updateUserRecord}
                  required
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
						variant="primary"
						onClick={validateInput}
						disabled={loading || !isValidated}>
            {loading ? <>
							<Spinner
								as="span"
								animation="border"
								size="sm"
								role="status"
								aria-hidden="true" /> {' '}
								Loading... </>
						: "Save User"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddUser;